export const LOAD_PAY_CONNECTED_PACKAGES_REQUEST = 'LOAD_PAY_CONNECTED_PACKAGES_REQUEST';
export const LOAD_PAY_CONNECTED_PACKAGES_SUCCESS = 'LOAD_PAY_CONNECTED_PACKAGES_SUCCESS';
export const LOAD_PAY_CONNECTED_PACKAGES_FAILURE = 'LOAD_PAY_CONNECTED_PACKAGES_FAILURE';

export const CANCEL_PAY_CONNECTED_PACKAGE_REQUEST = 'CANCEL_PAY_CONNECTED_PACKAGE_REQUEST';
export const CANCEL_PAY_CONNECTED_PACKAGE_SUCCESS = 'CANCEL_PAY_CONNECTED_PACKAGE_SUCCESS';
export const CANCEL_PAY_CONNECTED_PACKAGE_FAILURE = 'CANCEL_PAY_CONNECTED_PACKAGE_FAILURE';


export const LOAD_PAYMENT_METHODS_REQUEST = 'LOAD_PAYMENT_METHODS_REQUEST';
export const LOAD_PAYMENT_METHODS_SUCCESS = 'LOAD_PAYMENT_METHODS_SUCCESS';
export const LOAD_PAYMENT_METHODS_FAILURE = 'LOAD_PAYMENT_METHODS_FAILURE';
